import * as CryptoJS from 'crypto-js';
import { UUID } from 'angular2-uuid';

export class Auth {
  session_id: number;
  site: string;
  language: string;
  device: string;
  sign: string;
  persona: string;
  role: string;
  hash: string;

  constructor(site: string, language: string, device: string, persona: string, role: string) {
    this.site = site;
    this.language = language;
    this.device = device;
    this.persona = persona;
    this.role = role;
  }

  getHash(): string {
    return this.hash;
  }

  setLoginHash() {
    const _str = this.persona + this.site + this.language + this.device + this.sign;
    const _hash = CryptoJS.SHA256(_str);
    this.hash = _hash.toString();
  }

  getSign(): string {
    return this.sign;
  }

  setSign() {
    const myString: string = UUID.UUID();
    const _sign = CryptoJS.SHA256(myString);
    this.sign = _sign.toString();
  }

}

export class AuthResponse {
  access_token: string;
  expires_in?: number;
  token_type?: string;
  scope?: string;
  refresh_token: string;
}

/** Contexte d'une session tenue par le serveur, tel que rendu dans `x-bundle-recurring`. */
export interface SessionBundle {
  site: string;
  language: string;
  device: string;
  role: string;
  persona: string;
  session_id: number;
  bound: boolean;
}

/** Réponse de `POST auth/handoff/` : code d'ouverture d'une autre application. */
export interface SessionHandoff {
  code: string;
  expires_in: number;
  persona: string;
  site?: string;
  domain?: string;
  role?: string;
}

/** Réponse de `POST auth/exchange/` : session remise par un code à usage unique. */
export interface SessionExchange {
  access_token: string;
  token_type: string;
  expires_in: number;
  scope: string;
  session_id: number;
  signkey: string;
  bundle: SessionBundle;
}
